import { render, staticRenderFns } from "./PreviewJobfair.vue?vue&type=template&id=c83987aa"
import script from "./PreviewJobfair.vue?vue&type=script&lang=js"
export * from "./PreviewJobfair.vue?vue&type=script&lang=js"
import style0 from "./PreviewJobfair.vue?vue&type=style&index=0&id=c83987aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports